var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{staticClass:"text-center",attrs:{"timeout":_vm.timeout,"bottom":""},model:{value:(_vm.getDragBar),callback:function ($$v) {_vm.getDragBar=$$v},expression:"getDragBar"}},[_c('div',{staticClass:"text-center px-4 py-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }